// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {
    deleteFile,
    getFiles
} from '../../../product/shared/repositories';
import actions from '../../actions-list';

export const deleteFileRequest = fileToDelete =>

    async (dispatch, getState) => {

        const doesFileExists = getState().pips.pipCodeRequest.pipCode.file.some(item => item.fileName === fileToDelete.fileName && item.serialNumber === fileToDelete.serialNumber);

        if (doesFileExists) {

            dispatch(busyCounter.increaseBusyCounter());

            try {

                await deleteFile(fileToDelete);

                const files = await getFiles(fileToDelete);

                dispatch({
                    files,
                    type: actions.UPDATE_PIP_CODE_FILE_LIST
                });

            } catch (error) {

            } finally {

                dispatch(busyCounter.decreaseBusyCounter());

            }

        }

    };



// WEBPACK FOOTER //
// ./src/pip/pip-code/action-creators/delete-file.js